import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPMinutesSubstituteIconProps = StyledIconVariants & {
  css?: CSS;
};

export const SMPMinutesSubstituteIcon = (props: SMPMinutesSubstituteIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <svg fill='currentColor'>
        <mask id='mask0_911_62274' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='20' height='20'>
          <rect width='20' height='20' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_911_62274)'>
          <path
            d='M10 17.5C8.95833 17.5 7.98264 17.3021 7.07292 16.9062C6.16319 16.5104 5.37153 15.9757 4.69792 15.3021C4.02431 14.6285 3.48958 13.8368 3.09375 12.9271C2.69792 12.0174 2.5 11.0417 2.5 10C2.5 8.95833 2.69792 7.98264 3.09375 7.07292C3.48958 6.16319 4.02431 5.37153 4.69792 4.69792C5.37153 4.02431 6.16319 3.48958 7.07292 3.09375C7.98264 2.69792 8.95833 2.5 10 2.5C11.1389 2.5 12.2188 2.74306 13.2396 3.22917C14.2604 3.71528 15.125 4.40278 15.8333 5.29167V3.33333H17.5V8.33333H12.5V6.66667H14.7917C14.2222 5.88889 13.5208 5.27778 12.6875 4.83333C11.8542 4.38889 10.9583 4.16667 10 4.16667C8.375 4.16667 6.99653 4.73264 5.86458 5.86458C4.73264 6.99653 4.16667 8.375 4.16667 10C4.16667 11.625 4.73264 13.0035 5.86458 14.1354C6.99653 15.2674 8.375 15.8333 10 15.8333C11.4583 15.8333 12.7326 15.3611 13.8229 14.4167C14.9132 13.4722 15.5556 12.2778 15.75 10.8333H17.4583C17.25 12.7361 16.434 14.3229 15.0104 15.5938C13.5868 16.8646 11.9167 17.5 10 17.5ZM12.3333 13.5L9.16667 10.3333V5.83333H10.8333V9.66667L13.5 12.3333L12.3333 13.5Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </SMPIcon>
  );
};
